import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

/**
 * Single place for “use kiln-list (desktop split view) vs landing (swiper)”.
 * Matches post-login behavior on home: compact widths stay on landing.
 */
@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  constructor(private platform: Platform) {}

  /** True when navigation should target kiln-list instead of landing. */
  shouldUseKilnListRoute(): boolean {
    return this.platform.width() > 1024;
  }
}
